import type { FaireProductEntity } from "../../entity_types/product";

export const p_9ebbrg5tvp: FaireProductEntity = {
  token: "p_9ebbrg5tvp",
  type: "product",
  name: "Razorback Statement Earrings – Game Day Jewelry",
  brandToken: "b_hfw2t2ygt4",
  brandName: "Southern Designs by Kristy",
  imageUrl:
    "https://cdn.faire.com/fastly/8da97b9c087a762982b6b3e092fb8fba991d03ee637ebb3faca46f842a4437bd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9b116869b4b1e1a2f79c1d670f02e5992e61e42396c7e8d70c29847ae5c123c6.jpeg",
  ],
  priceDollars: 13.86,
  description:
    "Cheer on the Hogs in bold style with these must-have statement earrings! Featuring sparkling black druzy-style studs paired with fierce red Razorback faces, these earrings are perfect for every die-hard fan. Lightweight yet striking, they’ll complete your game day look with a punch of spirit and sparkle.\n\n✨ Details:\n\n * Handmade by Southern Designs by Kristy \n * Glittery black round studs with gold trim \n * Dangling red Razorback face design \n * Lightweight & comfortable for all-day wear \n * Approx. 2.5” drop length \n * Nickel-free, hypoallergenic posts \n🐗 Woo Pig Sooie! Whether you’re at the stadium, tailgating, or watching with friends, these earrings bring the perfect mix of team pride and trendy flair.\n",
  tags: [],
  msrpDollars: 27.71,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:01.844Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
